import React from "react";
import { TanAuthenticationWrapper } from "../components/tan-authentication/TanAuthenticationWrapper";
import { ContentSection, Main } from "@vwfs-bronson/bronson-react";
import { Header } from "../components/ui/Header";
import { Footer } from "../components/ui/Footer";

export const ContinuePage = () => {
    return (
        <div className="o-root">
            <Header />
            <Main>
                <ContentSection pageWrap>
                    <TanAuthenticationWrapper />
                </ContentSection>
            </Main>
            <Footer />
        </div>
    );
};
